import React, { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { t } from "../../locales/translate";
import { useLocation } from "react-router-dom";

function useLang() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  let lang = params.get("lang");
  // Accept both 'ne' and 'np' for Nepali
  if (lang === "np") lang = "ne";
  const supported = ["en", "ja", "ne", "zh", "ko"];
  return supported.includes(lang) ? lang : "en";
}

function useDarkMode() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const darkMode = params.get("dark");
  return darkMode === "true";
}

// Robustly extract the full url parameter including any hash
function getFullUrlParam() {
  const urlHash = window.location.hash.substring(1);
  const urlParam = new URLSearchParams(window.location.search).get("url");
  if (urlHash) {
    return urlParam + `#${urlHash}`;
  }
  return urlParam;
}

const SharePage = () => {
  const lang = useLang();
  const isDarkMode = useDarkMode();
  const url = getFullUrlParam();
  console.log(url);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);

  // Responsive QR code size
  const [qrSize, setQrSize] = React.useState(400);
  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) {
        setQrSize(Math.min(window.innerWidth - 48, 360));
      } else {
        setQrSize(400);
      }
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center p-4"
      style={{
        background: "var(--sa-bg-secondary)",
        width: "100%",
        height: "100vh",
        overflowX: "hidden",
        color: "var(--sa-text-primary)",
        transition: "background-color 0.3s ease, color 0.3s ease",
      }}
    >
      <div className="w-full max-w-md flex flex-col items-center mx-auto">
        <h1
          className="text-2xl font-bold mb-6 text-center"
          style={{ color: "var(--sa-text-primary)" }}
        >
          {t(lang, ["share", "title"])}
        </h1>
        <h4
          className="text-base text-center mb-2"
          style={{ color: "var(--sa-text-secondary)" }}
        >
          {t(lang, ["share", "description"])}
        </h4>
        <div className="flex flex-col items-center w-full h-full">
          <div
            className="flex items-center justify-center w-full rounded-3xl shadow-lg mb-6 mx-auto"
            style={{
              boxShadow: "var(--sa-card-shadow)",
              borderRadius: "var(--ShresthaApp-border-radius)",
              padding: 24,
              minHeight: qrSize,
              minWidth: qrSize,
              maxWidth: 400,
              maxHeight: 400,
              width: qrSize,
              height: qrSize,
              marginLeft: "auto",
              marginRight: "auto",
              aspectRatio: "1 / 1",
              background: "var(--sa-bg-primary)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "background-color 0.3s ease",
              marginBottom: 24,
            }}
          >
            <QRCodeSVG
              value={url}
              size={qrSize}
              bgColor="#fff"
              fgColor="#000000"
              className="mx-auto"
              style={{
                width: qrSize,
                height: qrSize,
                display: "block",
                padding: "10px",
                maxWidth: "100%",
                maxHeight: "100%",
                borderRadius: "var(--ShresthaApp-border-radius)",
              }}
            />
          </div>

          <div
            className="mt-2 text-center break-all text-base rounded p-3 w-full"
            style={{
              borderRadius: "var(--ShresthaApp-border-radius)",
              background: "var(--sa-bg-tertiary)",
              color: "var(--sa-button-secondary)",
              transition: "background-color 0.3s ease, color 0.3s ease",
              margin: 12,
            }}
          >
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "var(--sa-button-secondary)",
                textDecoration: "underline",
              }}
            >
              {url}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharePage;
